import React from 'react';
import { motion } from 'framer-motion';

/**
 * Fixed royal-blue ambient wash with two slowly drifting blurred orbs.
 * Shared by Rewards, Dashboard (Trips), and Search results.
 * Content layered above this should use `relative z-10` (or higher).
 */
export default function RoyalAmbientBackground() {
  return (
    <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-brand-950 via-[#050814] to-black" />

      {/* Reduced to 2 orbs for better performance */}
      <motion.div
        animate={{
          x: [0, 80, 0],
          y: [0, -60, 0],
        }}
        transition={{
          duration: 25,
          repeat: Infinity,
          ease: 'linear',
        }}
        className="absolute top-0 left-0 w-96 h-96 bg-brand-800/20 rounded-full blur-3xl"
        style={{ willChange: 'transform' }}
      />
      <motion.div
        animate={{
          x: [0, -80, 0],
          y: [0, 60, 0],
        }}
        transition={{
          duration: 30,
          repeat: Infinity,
          ease: 'linear',
        }}
        className="absolute bottom-0 right-0 w-[32rem] h-[32rem] bg-brand-900/25 rounded-full blur-3xl"
        style={{ willChange: 'transform' }}
      />
    </div>
  );
}
